import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  width: 100%;
  margin-bottom: 16px;
`;

export const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.md};
`;

export const StatLabel = styled.span`
  color: ${tokens.color.textAsh};
  font-size: 0.8rem;
`;

export const StatValue = styled.strong`
  color: ${tokens.color.textWhite};
  font-size: 1.35rem;
  font-weight: 600;
`;

/* ---- Seletor de curso (quando não há ?courseid=) ---- */

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 420px;
  margin-bottom: 16px;
  padding: 0 12px;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.pill};
  color: ${tokens.color.textAsh};
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 0;
  border: 0;
  background: transparent;
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};

  &::placeholder {
    color: ${tokens.color.textAsh};
  }

  &:focus {
    outline: none;
  }
`;

export const PickerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const PickerItem = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 10px 14px;
  text-align: left;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.md};
  color: ${tokens.color.textWhite};
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;

  &:hover {
    border-color: ${tokens.color.marqueeGold};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;
export const PickerThumb = styled.img`
  width: 72px;
  height: 44px;
  object-fit: cover;
  border-radius: ${tokens.radius.xs};
  flex-shrink: 0;
`;

export const PickerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const PickerTitle = styled.strong`
  font-size: ${tokens.font.body.size};
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PickerMeta = styled.span`
  font-size: ${tokens.font.caption.size};
  color: ${tokens.color.textAsh};
`;

export const EmptyHint = styled.p`
  padding: 32px 0;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
`;